import React, { useState } from 'react'
import {
  Box,
  Button,
  FormControl,
  Grid,
  Modal,
  TextField,
} from '@material-ui/core'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { insertProviderList } from '../../../../../services/AsistenciaTecnica/create'
import { updateProviderList } from '../../../../../services/AsistenciaTecnica/put'
import swal from 'sweetalert'

export const ModalLinkedIn = (props) => {
  const {
    open,
    setOpen,
    body,
    setBody,
    getProvider,
    IdTechnicalAssistanceAnswer,
  } = props

  const [loading, setLoading] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    ProviderLinkedIn: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /(https?:\/\/(www.)|(www.))?linkedin.com\/(mwlite\/|m\/)?in\/[a-zA-Z0-9_.-]+\/?/,
        'Debe registrar un perfil de Linkendin',
      )
      .typeError('Debe registrar un perfil de Linkendin')
      .max(500, 'Máximo 500 caracteres'),
    NameProvider: Yup.string()
      .required('Este campo es obligatorio')
      .max(150, 'Máximo 150 caracteres'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdProviderList: body.IdProviderList || 0,
      IdTechnicalAssistanceAnswer:
        body.IdTechnicalAssistanceAnswer || IdTechnicalAssistanceAnswer,
      ProviderLinkedIn: body.ProviderLinkedIn || '',
      NameProvider: body.NameProvider || '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values)
    },
  })

  const saveForm = async (values) => {
    setLoading(true)
    let response
    if (Object.keys(body).length === 0) {
      response = await insertProviderList(values)
    }
    if (Object.keys(body).length > 0) {
      response = await updateProviderList(values)
    }

    if (response.Success) {
      swal({
        title: '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getProvider()
      handleClose()
      setLoading(false)
    }
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
    setBody({})
  }
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Datos del perfil de LinkedIn</h1>
          </div>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Nombre <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: 220 }}
                  value={formik.values.NameProvider}
                  onChange={(e) =>
                    formik.setFieldValue(
                      'NameProvider',
                      e.target.value.trimStart(),
                    )
                  }
                  error={formik.errors.NameProvider}
                  inputProps={{
                    maxLength: 150,
                  }}
                />
                {formik.errors.NameProvider ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.NameProvider}
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Enlace <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: 220 }}
                  value={formik.values.ProviderLinkedIn}
                  onChange={(e) =>
                    formik.setFieldValue('ProviderLinkedIn', e.target.value)
                  }
                  error={formik.errors.ProviderLinkedIn}
                />
              </FormControl>
              {formik.errors.ProviderLinkedIn ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.ProviderLinkedIn}
                </div>
              ) : null}
            </Grid>

            <Grid className="buttonsPYME">
              <Button className="cancelButton" onClick={handleClose}>
                Cancelar
              </Button>
              <Button
                className="confirmButton"
                type="button"
                onClick={validateFormStatus}
                disabled={loading}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
